import { render, staticRenderFns } from "./forgot-password.vue?vue&type=template&id=20047860&scoped=true"
import script from "./forgot-password.vue?vue&type=script&lang=js"
export * from "./forgot-password.vue?vue&type=script&lang=js"
import style0 from "./forgot-password.vue?vue&type=style&index=0&id=20047860&prod&lang=scss"
import style1 from "./forgot-password.vue?vue&type=style&index=1&id=20047860&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20047860",
  null
  
)

export default component.exports